import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { MessagingChannelReplyMode } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { messagingReplyModeLabel } from '~pages/Messages/messagingChannelLabels';

type BroadcastPreviewProps = {
  message: string;
  recipientCount: number;
  replyMode: MessagingChannelReplyMode;
};

export default function BroadcastPreview({
  message,
  recipientCount,
  replyMode,
}: BroadcastPreviewProps) {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
      <Typography variant="subtitle2">
        {t('messaging.broadcast_preview_heading', { count: recipientCount })}
      </Typography>

      <Paper
        data-ui="broadcast-preview-message"
        elevation={0}
        sx={{ bgcolor: theme.semantic.actionHover, p: 2, whiteSpace: 'pre-wrap' }}
        variant="outlined"
      >
        <Typography variant="body2">{message}</Typography>
      </Paper>

      <Typography sx={{ color: theme.semantic.textSecondary }} variant="caption">
        {t('messaging.broadcast_preview_reply_mode', {
          replyMode: messagingReplyModeLabel(replyMode),
        })}
      </Typography>
    </Box>
  );
}
